import axios from 'axios'
import { useAuth0 } from '@auth0/auth0-react'
import { useEffect, useState } from 'react'

const useAxiosInterceptor = () => {
  const { getAccessTokenSilently } = useAuth0()
  const [isInterceptorReady, setIsInterceptorReady] = useState(false)

  useEffect(() => {
    const requestInterceptor = async config => {
      const token = await getAccessTokenSilently()
      if (token) {
        config.headers.Authorization = `Bearer ${token}`
      }
      return config
    }

    const errorInterceptor = error => Promise.reject(error)
    const responseInterceptor = response => response

    const requestInterceptorId = axios.interceptors.request.use(
      requestInterceptor,
      errorInterceptor
    )
    const responseInterceptorId = axios.interceptors.response.use(
      responseInterceptor,
      errorInterceptor
    )

    setIsInterceptorReady(true) // 🔥 Marca que el interceptor está listo

    return () => {
      axios.interceptors.request.eject(requestInterceptorId)
      axios.interceptors.response.eject(responseInterceptorId)
    }
  }, [getAccessTokenSilently])

  return {isInterceptorReady}
}

export default useAxiosInterceptor
